<template>
  <Loader :value="promises.fetchOne" theme="default">
    <Statistics :item="item" :addons="addons" :items="items" :tab="value" @tab:change="$ev => (value = $ev)" />
  </Loader>
</template>

<script>
import { mapState } from 'vuex'
import StorageMixin from '@/mixins/Storage'
import Statistics from '@/components/Dashboard/Statistics'
import moment from 'moment'

export default {
  mixins: [
    StorageMixin({
      target: 'value',
      async key() {
        await this.promises.fetchOne
        return `project:dashboard:statistics:${this.item.id}`
      },
      storage: 'localStorage',
    }),
  ],
  props: {
    addons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: 'analytics',
      range: {
        start: moment().startOf('year'),
        end: moment().endOf('year'),
      },
    }
  },
  computed: {
    ...mapState('Project', ['item', 'promises']),
    items() {
      return [
        { id: 'analytics', label: this.$t('statisticsVisitors') },
        {
          id: 'sales.residentials',
          label: `${this.$t('statisticsSalesResidentials')} - ${this.range.start.year()}`,
          condition: this.addons.includes('project:bid'),
        },
      ].filter(item => !('condition' in item) || item.condition)
    },
  },

  components: {
    Statistics,
  },
}
</script>
